<h1>Inspiration and background</h1>

<p>
  This project started back in February 2022.
  <br />
  As a kid, I was interested in cellular automata, and as an adult, I was fascinated
  by Stephen Wolfram's A New Kind of Science book ("NKS"). When I was a student,
  as a relief from boredom during courses, I used to endlessly draw repetitive patterns
  in my notebook. Also, I was always very fond of repetitive patterns where the eye
  follows a pattern and gets eventually trapped. I remember being stunned by Vazarely's
  Bellatrix at the Calouste Gulbenkian Museum.
</p>

<p>
  Thus, I initially wanted to play around 2D cellular automata, making it less
  regular, less stochastic, and much more chaotic.
  <br />
  I started with generating random evolution rules to decide whether a cell should
  be filled or not, very much like Conway's Game of Life. Then, I decided that "binary"
  cells (empty or not empty status) did not bring enough complexity. I designed each
  cell to be like a biological cell, defined by its DNA. New cells combine the DNA
  of surrounding cells, following random rules.
  <br />
  At last, I added mutations: whenever the DNA gets replicated, mutations can happen,
  leading - or not - to new characteristics.
</p>

<p>
  For the rendering, I transformed DNA features into simple graphical
  properties, leading to very repetitive patterns. I removed all straight lines
  to give it a very artisanal, handmade look.
  <br />
  I also designed the rendering for printing. Laser or inkjet printing leads to perfect
  results: this is exactly what I wanted to avoid. I wanted the printing device itself
  to add its randomness and its imperfections: printing twice with the same result
  must just be impossible. Thus, the ideal printing device for Reverie is the risograph:
  it will add multiple random imperfections - alignment, filling, fuzzy borders,
  etc. The 14 possible colours of Reverie are ones regularly found in risographs.
</p>

<p>The entire project took 22 months, with multiple long pauses.</p>
